import { getApiUrl } from '../utils/apiConfig';
import { fetchWithRetry } from '../utils/fetchWithRetry';
import { getAuthHeaders } from '../utils/userUtils';

const request = async (currentUser, path, options = {}) => {
  if (!currentUser) {
    throw new Error('로그인이 필요해요.');
  }
  const headers = await getAuthHeaders(currentUser);
  const method = String(options.method || 'GET').toUpperCase();
  let response;
  try {
    response = await fetchWithRetry(getApiUrl(path), {
      ...options,
      headers: {
        ...headers,
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {}),
      },
    }, {
      maxRetries: method === 'DELETE' ? 0 : 1,
      timeoutMs: 15_000,
      retryOnTimeout: method !== 'DELETE',
    });
  } catch (requestError) {
    const message = /[가-힣]/.test(requestError?.message || '')
      ? requestError.message
      : '네트워크 연결을 확인한 뒤 다시 시도해주세요.';
    const safeError = new Error(message);
    safeError.status = 0;
    throw safeError;
  }

  let payload = {};
  try {
    payload = await response.json();
  } catch (_error) {
    payload = {};
  }
  if (!response.ok) {
    const safeServerDetail = (
      typeof payload.detail === 'string'
      && payload.detail.length <= 200
      && /[가-힣]/.test(payload.detail)
    ) ? payload.detail : null;
    const messages = {
      401: '로그인 정보를 다시 확인해주세요.',
      404: safeServerDetail || '프롬프트를 찾을 수 없어요.',
      409: safeServerDetail || '저장 공간이 가득 찼어요. 사용하지 않는 프롬프트를 정리해주세요.',
      422: '입력한 내용을 다시 확인해주세요.',
    };
    const error = new Error(
      messages[response.status]
      || (
        response.status === 400
          ? (safeServerDetail || '입력한 내용을 다시 확인해주세요.')
          : '프롬프트를 처리하지 못했어요. 잠시 후 다시 시도해주세요.'
      )
    );
    error.status = response.status;
    throw error;
  }
  return payload;
};

export const listUserPrompts = (currentUser) => (
  request(currentUser, '/api/user/prompts')
);

export const createUserPrompt = (currentUser, { body, category, title }) => (
  request(currentUser, '/api/user/prompts', {
    method: 'POST',
    body: JSON.stringify({ body, category, ...(title ? { title } : {}) }),
  })
);

export const updateUserPrompt = (currentUser, promptId, { title, body }) => (
  request(
    currentUser,
    `/api/user/prompts/${encodeURIComponent(promptId)}`,
    {
      method: 'PATCH',
      body: JSON.stringify({
        ...(title !== undefined ? { title } : {}),
        ...(body !== undefined ? { body } : {}),
      }),
    }
  )
);

export const deleteUserPrompt = (currentUser, promptId) => (
  request(
    currentUser,
    `/api/user/prompts/${encodeURIComponent(promptId)}`,
    { method: 'DELETE' }
  )
);

export const recordUserPromptUse = (currentUser, promptId) => (
  request(
    currentUser,
    `/api/user/prompts/${encodeURIComponent(promptId)}/use`,
    { method: 'POST' }
  )
);
